import React from 'react';
import styles from '../../css/ControlPage.css';

const BudgetSummary = ({ budgetData, formatCurrency }) => {
  const { totalCost, budget, remaining, isExceeded } = budgetData;

  // console.log('BudgetSummary received:', { totalCost, budget, remaining, isExceeded });

  return (
    <div className="budget-summary">
      <p>Presupuesto total: {formatCurrency(budget)}</p>
      <p>Presupuesto utilizado: {formatCurrency(totalCost)}</p>
      <p className={isExceeded ? 'exceeded' : ''}>
        Presupuesto restante: {formatCurrency(Math.abs(remaining))}
        {isExceeded && ` (Excedido por ${formatCurrency(Math.abs(remaining))})`}
      </p>
    </div>
  );
};

export default BudgetSummary;

